/**
 * The wall search's trimmed query for the Pinned tiles (Part 09 decision 2):
 * each live tool filters itself in place. Empty while nothing is searched.
 */
import { createContext, useContext } from "react";

export const WallTileQueryContext = createContext("");

export function useWallTileQuery(): string {
  return useContext(WallTileQueryContext);
}
